export function createReducer(initialState, reducerMap) {
  return (state = initialState, action) => {
    const reducer = reducerMap[action.type];

    return reducer ?
      reducer(state, action.payload) :
      state;
  };
}

export const debounce = (delay, func) => {
  let timerId;

  return (options) => {
    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(() => {
      timerId = 0;
      return func(options);
    }, delay);
  };
};

export const onChangeNotify = (fn, e)  => {
  const { target: { name, value } } = e;
  fn({name, value });
};

export const responseOkay = (response) => {
  if (response.status >= 200 && response.status < 400) {
    return response;
  }
  throw new Error(response);
}


// WEBPACK FOOTER //
// ./src/utils/index.js